export const ACCESS_CONFIG = {
  FULL_ACCESS_ENABLED: true,
  ALLOW_EDIT_ALL_FILES: true,
  ALLOW_FULL_ACCESS_SHARED_MAPS: true
};
